<!-- 
    Types:
        - number
        - money
        - money_short
        - money_space
        - money_dot

 -->

<template>
    {{ formatedNumber }}
</template>

<script>
export default {
    props: {
        animNumber: {
            type: Number,
            required: true
        },
        animDuration: {
            type: Number,
            default: 1000
        },
        animDelay: {
            type: Number,
            default: 0
        },
        numberType: {
            type: String,
            default: 'number'
        }
    },
    data() {
        return {
            twinstedNumber: 0
        }
    },
    methods: {
        animateNumbers: function(oldNumber, newNumber, time) {
            let positiveAnimate = true;
            if (oldNumber > newNumber) positiveAnimate = false;

            let intervalStep = Math.round((newNumber - oldNumber) / (time / 10));
            let interval = setInterval(() => {
                let thisIntervalStep = intervalStep;
                if (intervalStep < 1 && positiveAnimate) thisIntervalStep = 1;
                else if (intervalStep > -1 && !positiveAnimate) thisIntervalStep = -1;

                // let thisValueNow = objFromString(this, changeParam)
                // if (thisValueNow < newNumber && positiveAnimate) {
                //     objFromString(this, changeParam, (thisValueNow + thisIntervalStep))
                // } else if (thisValueNow > newNumber && !positiveAnimate) {
                //     objFromString(this, changeParam, (thisValueNow + thisIntervalStep))
                // } else {
                //     if (thisValueNow > newNumber || thisValueNow < newNumber) {
                //         objFromString(this, changeParam, newNumber)
                //     }
                //     clearInterval(interval);
                // }

                if (this.twinstedNumber < newNumber && positiveAnimate) {
                    this.twinstedNumber += thisIntervalStep;
                } else if (this.twinstedNumber > newNumber && !positiveAnimate) {
                    this.twinstedNumber += thisIntervalStep;
                } else {
                    if (this.twinstedNumber > newNumber || this.twinstedNumber < newNumber) {
                        this.twinstedNumber = newNumber;
                    }
                    clearInterval(interval);
                }
            }, 10);

            // function objFromString(obj, is, value) {
            //     if (typeof is == 'string')
            //         return objFromString(obj,is.split('.'), value);
            //     else if (is.length==1 && value!==undefined)
            //         return obj[is[0]] = value;
            //     else if (is.length==0)
            //         return obj;
            //     else
            //         return objFromString(obj[is[0]],is.slice(1), value);
            // }
        }
    },
    computed: {
        formatedNumber() {
            if (this.numberType == 'money') {
                return Math.round(this.twinstedNumber).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            } else if (this.numberType == 'money_space') {
                return Math.round(this.twinstedNumber).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
            } else if (this.numberType == 'money_dot') {
                return Math.round(this.twinstedNumber).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            } else if (this.numberType == 'money_short') {
                let moneyRounded = Math.round(this.twinstedNumber)
                if (moneyRounded >= 1000000000) {
                    return (moneyRounded / 1000000000).toFixed(1) + 'B';
                } else if (moneyRounded >= 1000000) {
                    return (moneyRounded / 1000000).toFixed(1) + 'M';
                } else if (moneyRounded >= 1000) {
                    return (moneyRounded / 1000).toFixed(1) + 'K';
                } else {
                    return moneyRounded;
                }
            } else {
                return this.twinstedNumber
            }
        }
    },
    watch: {
        'animNumber': function(newValue, oldValue) {
            this.animateNumbers(oldValue, newValue, this.animDuration);
        }
    },
    mounted() {
        if (this.animDelay > 0) {
            setTimeout(() => {
                this.animateNumbers(0, this.animNumber, this.animDuration);
            }, this.animDelay);
        } else {
            this.twinstedNumber = this.animNumber;
        }
    }
}

</script>

<style>

</style>